import {useEffect} from "react";
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';

import {createStore as create} from "./common/util/createStore";
import {useCommonPages} from "./common/useCommonPages";
import Home from "./Home";


export const DEVMODE = window.location.hostname.match('localhost')
export const BASEPATH = DEVMODE ? '/app/' : '/dashboard/'
export const PWLOGIN = false;

export const useAppConfigStore = create((set) => ({
    name: 'DEA Dashboard',
    helplink: '',
    pages: [],
    setPages: pages => set({ pages }),
    preload: [],
}))

export const LoadPages = () => {
    console.log('redraw', 'LoadPages');
    const setPages = useAppConfigStore(state => state.setPages);
    const commonPages = useCommonPages();

    useEffect(() => setPages([
        ['Home', '/', <Home />, { icon: <SpaceDashboardOutlinedIcon /> }],
        ...commonPages,
    ]), [setPages, commonPages]);
}
